"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var osa = require("@wk/osa");
require("@wk/osa-common");
var common = require("@wk/osa-common");
/**
 * @copyright
 * Copyright (c) 2003-2021 Wolters Kluwer Technology B.V. and/or its affiliates. All Rights Reserved.
 *
 * This source code (the "Software") is the confidential and proprietary information of
 * Wolters Kluwer Technology BV and/or its affiliates. The Software contains trade secret information,
 * and you may not reverse-engineer, decompile, disclose, copy, modify, upload, download, transmit,
 * republish, or otherwise misappropriate the Software without the express written approval of
 * Wolters Kluwer Technology BV and/or its affiliates. In addition, the Software is protected by U.S.
 * and other applicable copyright laws. The Software is provided solely for the purpose of technical
 * analysis within the scope of a single project, subject to applicable license requirements set forth
 * by Wolters Kluwer Technology BV and/or its affiliates. All copies of this Software must be destroyed
 * or otherwise removed from your system and any associated hardware when any applicable license terminates
 * or expires.
 */
var search;
(function (search) {
    osa.attachDomain(search, 'Search', '2.0.16');
})(search || (search = {}));
(function (search) {
    /**
    * Enum AdjustmentType
    *
    *
    */
    var AdjustmentType;
    (function (AdjustmentType) {
        AdjustmentType[AdjustmentType["QueryTerm"] = 0] = "QueryTerm"; /* = 'QueryTerm'*/
        AdjustmentType[AdjustmentType["FilterAsFilter"] = 1] = "FilterAsFilter"; /* = 'FilterAsFilter'*/
        AdjustmentType[AdjustmentType["FilterAsClause"] = 2] = "FilterAsClause"; /* = 'FilterAsClause'*/
        AdjustmentType[AdjustmentType["Phrase"] = 3] = "Phrase"; /* = 'Phrase'*/
        AdjustmentType[AdjustmentType["Alternative"] = 4] = "Alternative"; /* = 'Alternative'*/
        AdjustmentType[AdjustmentType["DateRangeClause"] = 5] = "DateRangeClause"; /* = 'DateRangeClause'*/
        AdjustmentType[AdjustmentType["DateRangeFilter"] = 6] = "DateRangeFilter"; /* = 'DateRangeFilter'*/
        AdjustmentType[AdjustmentType["DateRangeAlternative"] = 7] = "DateRangeAlternative"; /* = 'DateRangeAlternative'*/
        AdjustmentType[AdjustmentType["Normalization"] = 8] = "Normalization"; /* = 'Normalization'*/
        AdjustmentType[AdjustmentType["ScopedAlternative"] = 9] = "ScopedAlternative"; /* = 'ScopedAlternative'*/
        AdjustmentType[AdjustmentType["SelectConcept"] = 10] = "SelectConcept"; /* = 'SelectConcept'*/
        AdjustmentType[AdjustmentType["ClientQuoted"] = 11] = "ClientQuoted"; /* = 'ClientQuoted'*/
        AdjustmentType[AdjustmentType["FuzzyMatch"] = 12] = "FuzzyMatch"; /* = 'FuzzyMatch'*/
        AdjustmentType[AdjustmentType["GeneralFeedback"] = 13] = "GeneralFeedback"; /* = 'GeneralFeedback'*/
        AdjustmentType[AdjustmentType["SearchPatternsNormalization"] = 14] = "SearchPatternsNormalization"; /* = 'SearchPatternsNormalization'*/
        AdjustmentType[AdjustmentType["QueryCorrection"] = 15] = "QueryCorrection"; /* = 'QueryCorrection'*/
    })(AdjustmentType = search.AdjustmentType || (search.AdjustmentType = {}));
})(search || (search = {}));
(function (search) {
    /**
    * Enum AdvancedFacetSpecType
    *
    *
    */
    var AdvancedFacetSpecType;
    (function (AdvancedFacetSpecType) {
        AdvancedFacetSpecType[AdvancedFacetSpecType["AdvancedField"] = 0] = "AdvancedField"; /* = 'AdvancedField'*/
        AdvancedFacetSpecType[AdvancedFacetSpecType["AdvancedQuery"] = 1] = "AdvancedQuery"; /* = 'AdvancedQuery'*/
        AdvancedFacetSpecType[AdvancedFacetSpecType["AdvancedDateRange"] = 2] = "AdvancedDateRange"; /* = 'AdvancedDateRange'*/
    })(AdvancedFacetSpecType = search.AdvancedFacetSpecType || (search.AdvancedFacetSpecType = {}));
})(search || (search = {}));
(function (search) {
    /**
    * Enum BooleanOperator
    *
    *
    */
    var BooleanOperator;
    (function (BooleanOperator) {
        BooleanOperator[BooleanOperator["AND"] = 0] = "AND"; /* = 'AND'*/
        BooleanOperator[BooleanOperator["OR"] = 1] = "OR"; /* = 'OR'*/
    })(BooleanOperator = search.BooleanOperator || (search.BooleanOperator = {}));
})(search || (search = {}));
(function (search) {
    /**
    * Enum FacetSortType
    * Facet sorting is always ascending when alphabetical, and descending when count
    *
    */
    var FacetSortType;
    (function (FacetSortType) {
        FacetSortType[FacetSortType["Alphabetical"] = 0] = "Alphabetical"; /* = 'Alphabetical'*/
        FacetSortType[FacetSortType["Count"] = 1] = "Count"; /* = 'Count'*/
    })(FacetSortType = search.FacetSortType || (search.FacetSortType = {}));
})(search || (search = {}));
(function (search) {
    /**
    * Enum FacetSpecType
    *
    *
    */
    var FacetSpecType;
    (function (FacetSpecType) {
        FacetSpecType[FacetSpecType["Field"] = 0] = "Field"; /* = 'Field'*/
        FacetSpecType[FacetSpecType["NumericRange"] = 1] = "NumericRange"; /* = 'NumericRange'*/
        FacetSpecType[FacetSpecType["Hierarchy"] = 2] = "Hierarchy"; /* = 'Hierarchy'*/
    })(FacetSpecType = search.FacetSpecType || (search.FacetSpecType = {}));
})(search || (search = {}));
(function (search) {
    /**
    * Enum FieldType
    *
    *
    */
    var FieldType;
    (function (FieldType) {
        FieldType[FieldType["String"] = 0] = "String"; /* = 'String'*/
        FieldType[FieldType["Integer"] = 1] = "Integer"; /* = 'Integer'*/
        FieldType[FieldType["Long"] = 2] = "Long"; /* = 'Long'*/
        FieldType[FieldType["Float"] = 3] = "Float"; /* = 'Float'*/
        FieldType[FieldType["Datetime"] = 4] = "Datetime"; /* = 'Datetime'*/
        FieldType[FieldType["Boolean"] = 5] = "Boolean"; /* = 'Boolean'*/
        FieldType[FieldType["Double"] = 6] = "Double"; /* = 'Double'*/
    })(FieldType = search.FieldType || (search.FieldType = {}));
})(search || (search = {}));
(function (search) {
    /**
    * Enum FilterSpecType
    *
    *
    */
    var FilterSpecType;
    (function (FilterSpecType) {
        FilterSpecType[FilterSpecType["Terms"] = 0] = "Terms"; /* = 'Terms'*/
        FilterSpecType[FilterSpecType["NumericRange"] = 1] = "NumericRange"; /* = 'NumericRange'*/
        FilterSpecType[FilterSpecType["Query"] = 2] = "Query"; /* = 'Query'*/
        FilterSpecType[FilterSpecType["Complex"] = 3] = "Complex"; /* = 'Complex'*/
        FilterSpecType[FilterSpecType["NoValue"] = 4] = "NoValue"; /* = 'NoValue'*/
    })(FilterSpecType = search.FilterSpecType || (search.FilterSpecType = {}));
})(search || (search = {}));
(function (search) {
    /**
    * Enum FragmentSortType
    * Fragments sorting by score is always descending, and by position is always ascending
    *
    */
    var FragmentSortType;
    (function (FragmentSortType) {
        FragmentSortType[FragmentSortType["Score"] = 0] = "Score"; /* = 'Score'*/
        FragmentSortType[FragmentSortType["Position"] = 1] = "Position"; /* = 'Position'*/
    })(FragmentSortType = search.FragmentSortType || (search.FragmentSortType = {}));
})(search || (search = {}));
(function (search) {
    /**
    * Enum FragmentStyle
    * Drives how document fragments are presented: no fragments, the full fragment text, hit highlight offsets, or both
    *
    */
    var FragmentStyle;
    (function (FragmentStyle) {
        FragmentStyle[FragmentStyle["None"] = 0] = "None"; /* = 'None'*/
        FragmentStyle[FragmentStyle["TextOnly"] = 1] = "TextOnly"; /* = 'TextOnly'*/
        FragmentStyle[FragmentStyle["TermOffsetsOnly"] = 2] = "TermOffsetsOnly"; /* = 'TermOffsetsOnly'*/
        FragmentStyle[FragmentStyle["TextAndOffsets"] = 3] = "TextAndOffsets"; /* = 'TextAndOffsets'*/
        FragmentStyle[FragmentStyle["HighlightTextOnly"] = 4] = "HighlightTextOnly"; /* = 'HighlightTextOnly'*/
    })(FragmentStyle = search.FragmentStyle || (search.FragmentStyle = {}));
})(search || (search = {}));
(function (search) {
    /**
    * Enum HighlightType
    *
    *
    */
    var HighlightType;
    (function (HighlightType) {
        HighlightType[HighlightType["Disable"] = 0] = "Disable"; /* = 'Disable'*/
        HighlightType[HighlightType["FullText"] = 1] = "FullText"; /* = 'FullText'*/
        HighlightType[HighlightType["Snippets"] = 2] = "Snippets"; /* = 'Snippets'*/
    })(HighlightType = search.HighlightType || (search.HighlightType = {}));
})(search || (search = {}));
(function (search) {
    /**
    * Enum Language
    *
    *
    */
    var Language;
    (function (Language) {
        Language[Language["en"] = 0] = "en"; /* = 'en'*/
        Language[Language["nl"] = 1] = "nl"; /* = 'nl'*/
        Language[Language["fr"] = 2] = "fr"; /* = 'fr'*/
        Language[Language["de"] = 3] = "de"; /* = 'de'*/
        Language[Language["sv"] = 4] = "sv"; /* = 'sv'*/
        Language[Language["it"] = 5] = "it"; /* = 'it'*/
        Language[Language["es"] = 6] = "es"; /* = 'es'*/
        Language[Language["pl"] = 7] = "pl"; /* = 'pl'*/
        Language[Language["cs"] = 8] = "cs"; /* = 'cs'*/
        Language[Language["hu"] = 9] = "hu"; /* = 'hu'*/
        Language[Language["sk"] = 10] = "sk"; /* = 'sk'*/
    })(Language = search.Language || (search.Language = {}));
})(search || (search = {}));
(function (search) {
    /**
    * Enum NodeType
    *
    *
    */
    var NodeType;
    (function (NodeType) {
        NodeType[NodeType["ASTStart"] = 0] = "ASTStart"; /* = 'ASTStart'*/
        NodeType[NodeType["ASTExpression"] = 1] = "ASTExpression"; /* = 'ASTExpression'*/
        NodeType[NodeType["ASTFilterExpression"] = 2] = "ASTFilterExpression"; /* = 'ASTFilterExpression'*/
        NodeType[NodeType["ASTBoostExpression"] = 3] = "ASTBoostExpression"; /* = 'ASTBoostExpression'*/
        NodeType[NodeType["ASTGroup"] = 4] = "ASTGroup"; /* = 'ASTGroup'*/
        NodeType[NodeType["ASTConcept"] = 5] = "ASTConcept"; /* = 'ASTConcept'*/
        NodeType[NodeType["ASTQuoted"] = 6] = "ASTQuoted"; /* = 'ASTQuoted'*/
        NodeType[NodeType["ASTTerm"] = 7] = "ASTTerm"; /* = 'ASTTerm'*/
        NodeType[NodeType["ASTOr"] = 8] = "ASTOr"; /* = 'ASTOr'*/
        NodeType[NodeType["ASTAnd"] = 9] = "ASTAnd"; /* = 'ASTAnd'*/
        NodeType[NodeType["ASTNot"] = 10] = "ASTNot"; /* = 'ASTNot'*/
        NodeType[NodeType["ASTField"] = 11] = "ASTField"; /* = 'ASTField'*/
        NodeType[NodeType["ASTWithin"] = 12] = "ASTWithin"; /* = 'ASTWithin'*/
        NodeType[NodeType["ASTFollow"] = 13] = "ASTFollow"; /* = 'ASTFollow'*/
        NodeType[NodeType["ASTPreceed"] = 14] = "ASTPreceed"; /* = 'ASTPreceed'*/
        NodeType[NodeType["ASTSection"] = 15] = "ASTSection"; /* = 'ASTSection'*/
        NodeType[NodeType["ASTParagraph"] = 16] = "ASTParagraph"; /* = 'ASTParagraph'*/
        NodeType[NodeType["ASTDateRange"] = 17] = "ASTDateRange"; /* = 'ASTDateRange'*/
    })(NodeType = search.NodeType || (search.NodeType = {}));
})(search || (search = {}));
(function (search) {
    /**
    * Enum PackageStatus
    *
    *
    */
    var PackageStatus;
    (function (PackageStatus) {
        PackageStatus[PackageStatus["Received"] = 0] = "Received"; /* = 'Received'*/
        PackageStatus[PackageStatus["Completed"] = 1] = "Completed"; /* = 'Completed'*/
        PackageStatus[PackageStatus["CompletedWithErrors"] = 2] = "CompletedWithErrors"; /* = 'CompletedWithErrors'*/
        PackageStatus[PackageStatus["Failed"] = 3] = "Failed"; /* = 'Failed'*/
        PackageStatus[PackageStatus["InProgress"] = 4] = "InProgress"; /* = 'InProgress'*/
        PackageStatus[PackageStatus["Queued"] = 5] = "Queued"; /* = 'Queued'*/
        PackageStatus[PackageStatus["Assigned"] = 6] = "Assigned"; /* = 'Assigned'*/
        PackageStatus[PackageStatus["Skipped"] = 7] = "Skipped"; /* = 'Skipped'*/
        PackageStatus[PackageStatus["Requeued"] = 8] = "Requeued"; /* = 'Requeued'*/
        PackageStatus[PackageStatus["ForceFailed"] = 9] = "ForceFailed"; /* = 'ForceFailed'*/
        PackageStatus[PackageStatus["Suspended"] = 10] = "Suspended"; /* = 'Suspended'*/
    })(PackageStatus = search.PackageStatus || (search.PackageStatus = {}));
})(search || (search = {}));
(function (search) {
    /**
    * Enum PackageType
    *
    *
    */
    var PackageType;
    (function (PackageType) {
        PackageType[PackageType["Content"] = 0] = "Content"; /* = 'Content'*/
        PackageType[PackageType["Dictionary"] = 1] = "Dictionary"; /* = 'Dictionary'*/
    })(PackageType = search.PackageType || (search.PackageType = {}));
})(search || (search = {}));
(function (search) {
    /**
    * Enum SortDirection
    *
    *
    */
    var SortDirection;
    (function (SortDirection) {
        SortDirection[SortDirection["Ascending"] = 0] = "Ascending"; /* = 'Ascending'*/
        SortDirection[SortDirection["Descending"] = 1] = "Descending"; /* = 'Descending'*/
    })(SortDirection = search.SortDirection || (search.SortDirection = {}));
})(search || (search = {}));
(function (search) {
    /**
    * Enum StatFacetType
    *
    *
    */
    var StatFacetType;
    (function (StatFacetType) {
        StatFacetType[StatFacetType["UniqueValuesCount"] = 0] = "UniqueValuesCount"; /* = 'UniqueValuesCount'*/
    })(StatFacetType = search.StatFacetType || (search.StatFacetType = {}));
})(search || (search = {}));
(function (search) {
    /**
    * Enum SyntaxFaultType
    *
    *
    */
    var SyntaxFaultType;
    (function (SyntaxFaultType) {
        SyntaxFaultType[SyntaxFaultType["InvalidSyntax"] = 0] = "InvalidSyntax"; /* = 'InvalidSyntax'*/
        SyntaxFaultType[SyntaxFaultType["InvalidQuoteSyntax"] = 1] = "InvalidQuoteSyntax"; /* = 'InvalidQuoteSyntax'*/
        SyntaxFaultType[SyntaxFaultType["InvalidBooleanOrProximityExpression"] = 2] = "InvalidBooleanOrProximityExpression"; /* = 'InvalidBooleanOrProximityExpression'*/
        SyntaxFaultType[SyntaxFaultType["InvalidDateRepresentation"] = 3] = "InvalidDateRepresentation"; /* = 'InvalidDateRepresentation'*/
        SyntaxFaultType[SyntaxFaultType["InvalidProximityOperator"] = 4] = "InvalidProximityOperator"; /* = 'InvalidProximityOperator'*/
    })(SyntaxFaultType = search.SyntaxFaultType || (search.SyntaxFaultType = {}));
})(search || (search = {}));
(function (search) {
    var Add = /** @class */ (function (_super) {
        __extends(Add, _super);
        /**
        *
        * @param data - an initial data
        */
        function Add(data) {
            return _super.call(this, data) || this;
        }
        Add = __decorate([
            osa.decorators.ComplexType(search, 'search.Add', {
                'DocumentId': { n: 'documentId', t: 2 },
                'CollectionId': { n: 'collectionId', t: 2 },
                'MasterCollection': { n: 'masterCollection', t: 2 },
                'Source': { n: 'source', t: 2 },
                'DocumentLanguage': { n: 'documentLanguage', t: 4, r2: function () { return search.Language; } },
                'MimeType': { n: 'mimeType', t: 2 },
                'PropertyValue': { n: 'propertyValue', r: 'search.PropertyValue', r2: function () { return search.PropertyValue; }, f: 5 }
            })
        ], Add);
        return Add;
    }(osa.base.Complex));
    search.Add = Add;
})(search || (search = {}));
(function (search) {
    var AdvancedDateRangeFacet = /** @class */ (function (_super) {
        __extends(AdvancedDateRangeFacet, _super);
        /**
        *
        * @param data - an initial data
        */
        function AdvancedDateRangeFacet(data) {
            return _super.call(this, data) || this;
        }
        AdvancedDateRangeFacet = __decorate([
            osa.decorators.ComplexType(search, 'search.AdvancedDateRangeFacet', {
                'FieldName': { n: 'fieldName', t: 2 },
                'Start': { n: 'start', t: 2 },
                'End': { n: 'end', t: 2 },
                'Interval': { n: 'interval', t: 2 },
                'StatFacet': { n: 'statFacet', r: 'search.StatFunctionFacetSpec', r2: function () { return search.StatFunctionFacetSpec; }, f: 5 },
                'SubFacets': { n: 'subFacets', r: 'search.AdvancedFacetSpec', r2: function () { return search.AdvancedFacetSpec; }, f: 5 }
            })
        ], AdvancedDateRangeFacet);
        return AdvancedDateRangeFacet;
    }(osa.base.Complex));
    search.AdvancedDateRangeFacet = AdvancedDateRangeFacet;
})(search || (search = {}));
(function (search) {
    var AdvancedFacetDomainSpec = /** @class */ (function (_super) {
        __extends(AdvancedFacetDomainSpec, _super);
        /**
        *
        * @param data - an initial data
        */
        function AdvancedFacetDomainSpec(data) {
            return _super.call(this, data) || this;
        }
        AdvancedFacetDomainSpec = __decorate([
            osa.decorators.ComplexType(search, 'search.AdvancedFacetDomainSpec', {
                'DomainFilterExclusions': { n: 'domainFilterExclusions', r: 'search.DomainFilterExclusion', r2: function () { return search.DomainFilterExclusion; }, f: 1 }
            })
        ], AdvancedFacetDomainSpec);
        return AdvancedFacetDomainSpec;
    }(osa.base.Complex));
    search.AdvancedFacetDomainSpec = AdvancedFacetDomainSpec;
})(search || (search = {}));
(function (search) {
    var AdvancedFacetGroup = /** @class */ (function (_super) {
        __extends(AdvancedFacetGroup, _super);
        /**
        *
        * @param data - an initial data
        */
        function AdvancedFacetGroup(data) {
            return _super.call(this, data) || this;
        }
        AdvancedFacetGroup = __decorate([
            osa.decorators.ComplexType(search, 'search.AdvancedFacetGroup', {
                'FacetTag': { n: 'facetTag', t: 2 },
                'NumBuckets': { n: 'numBuckets', t: 9 },
                'FacetResults': { n: 'facetResults', r: 'search.AdvancedFacetResult', r2: function () { return search.AdvancedFacetResult; }, f: 5 }
            })
        ], AdvancedFacetGroup);
        return AdvancedFacetGroup;
    }(osa.base.Complex));
    search.AdvancedFacetGroup = AdvancedFacetGroup;
})(search || (search = {}));
(function (search) {
    var AdvancedFacetResult = /** @class */ (function (_super) {
        __extends(AdvancedFacetResult, _super);
        /**
        *
        * @param data - an initial data
        */
        function AdvancedFacetResult(data) {
            return _super.call(this, data) || this;
        }
        AdvancedFacetResult = __decorate([
            osa.decorators.ComplexType(search, 'search.AdvancedFacetResult', {
                'BucketValue': { n: 'bucketValue', t: 2 },
                'HitCount': { n: 'hitCount', t: 10 },
                'StatResults': { n: 'statResults', r: 'search.StatFacetResult', r2: function () { return search.StatFacetResult; }, f: 5 },
                'SubFacetResults': { n: 'subFacetResults', r: 'search.AdvancedFacetGroup', r2: function () { return search.AdvancedFacetGroup; }, f: 5 }
            })
        ], AdvancedFacetResult);
        return AdvancedFacetResult;
    }(osa.base.Complex));
    search.AdvancedFacetResult = AdvancedFacetResult;
})(search || (search = {}));
(function (search) {
    var AdvancedFacetSpec = /** @class */ (function (_super) {
        __extends(AdvancedFacetSpec, _super);
        /**
        *
        * @param data - an initial data
        */
        function AdvancedFacetSpec(data) {
            return _super.call(this, data) || this;
        }
        AdvancedFacetSpec = __decorate([
            osa.decorators.ComplexType(search, 'search.AdvancedFacetSpec', {
                'FacetSpecType': { n: 'facetSpecType', t: 4, r2: function () { return search.AdvancedFacetSpecType; } },
                'FacetTag': { n: 'facetTag', t: 2 },
                'FacetByField': { n: 'facetByField', r: 'search.AdvancedFieldFacet', r2: function () { return search.AdvancedFieldFacet; }, f: 1 },
                'FacetByDateRange': { n: 'facetByDateRange', r: 'search.AdvancedDateRangeFacet', r2: function () { return search.AdvancedDateRangeFacet; }, f: 1 },
                'FacetByQuery': { n: 'facetByQuery', r: 'search.AdvancedQueryFacet', r2: function () { return search.AdvancedQueryFacet; }, f: 1 },
                'DomainOverrideSpec': { n: 'domainOverrideSpec', r: 'search.AdvancedFacetDomainSpec', r2: function () { return search.AdvancedFacetDomainSpec; }, f: 1 }
            })
        ], AdvancedFacetSpec);
        return AdvancedFacetSpec;
    }(osa.base.Complex));
    search.AdvancedFacetSpec = AdvancedFacetSpec;
})(search || (search = {}));
(function (search) {
    var AdvancedFieldFacet = /** @class */ (function (_super) {
        __extends(AdvancedFieldFacet, _super);
        /**
        *
        * @param data - an initial data
        */
        function AdvancedFieldFacet(data) {
            return _super.call(this, data) || this;
        }
        AdvancedFieldFacet = __decorate([
            osa.decorators.ComplexType(search, 'search.AdvancedFieldFacet', {
                'FieldName': { n: 'fieldName', t: 2 },
                'MinCount': { n: 'minCount', t: 9 },
                'Prefix': { n: 'prefix', t: 2 },
                'Sort': { n: 'sort', t: 4, r2: function () { return search.FacetSortType; } },
                'SortDirection': { n: 'sortDirection', t: 4, r2: function () { return search.SortDirection; } },
                'Limit': { n: 'limit', t: 9 },
                'Offset': { n: 'offset', t: 9 },
                'IncludeMissingFacetCount': { n: 'includeMissingFacetCount', t: 1 },
                'Level': { n: 'level', t: 9 },
                'StatFacet': { n: 'statFacet', r: 'search.StatFunctionFacetSpec', r2: function () { return search.StatFunctionFacetSpec; }, f: 5 },
                'SubFacets': { n: 'subFacets', r: 'search.AdvancedFacetSpec', r2: function () { return search.AdvancedFacetSpec; }, f: 5 }
            })
        ], AdvancedFieldFacet);
        return AdvancedFieldFacet;
    }(osa.base.Complex));
    search.AdvancedFieldFacet = AdvancedFieldFacet;
})(search || (search = {}));
(function (search) {
    var AdvancedQueryFacet = /** @class */ (function (_super) {
        __extends(AdvancedQueryFacet, _super);
        /**
        *
        * @param data - an initial data
        */
        function AdvancedQueryFacet(data) {
            return _super.call(this, data) || this;
        }
        AdvancedQueryFacet = __decorate([
            osa.decorators.ComplexType(search, 'search.AdvancedQueryFacet', {
                'Query': { n: 'query', t: 2 },
                'StatFacet': { n: 'statFacet', r: 'search.StatFunctionFacetSpec', r2: function () { return search.StatFunctionFacetSpec; }, f: 5 },
                'SubFacets': { n: 'subFacets', r: 'search.AdvancedFacetSpec', r2: function () { return search.AdvancedFacetSpec; }, f: 5 }
            })
        ], AdvancedQueryFacet);
        return AdvancedQueryFacet;
    }(osa.base.Complex));
    search.AdvancedQueryFacet = AdvancedQueryFacet;
})(search || (search = {}));
(function (search) {
    var AdvancedReturnField = /** @class */ (function (_super) {
        __extends(AdvancedReturnField, _super);
        /**
        *
        * @param data - an initial data
        */
        function AdvancedReturnField(data) {
            return _super.call(this, data) || this;
        }
        AdvancedReturnField = __decorate([
            osa.decorators.ComplexType(search, 'search.AdvancedReturnField', {
                'FieldName': { n: 'fieldName', t: 2 },
                'HighlightType': { n: 'highlightType', t: 4, r2: function () { return search.HighlightType; } }
            })
        ], AdvancedReturnField);
        return AdvancedReturnField;
    }(osa.base.Complex));
    search.AdvancedReturnField = AdvancedReturnField;
})(search || (search = {}));
(function (search) {
    var AnnotationItem = /** @class */ (function (_super) {
        __extends(AnnotationItem, _super);
        /**
        *
        * @param data - an initial data
        */
        function AnnotationItem(data) {
            return _super.call(this, data) || this;
        }
        AnnotationItem = __decorate([
            osa.decorators.ComplexType(search, 'search.AnnotationItem', {
                'Name': { n: 'name', t: 2 },
                'SingleValue': { n: 'singleValue', t: 2 },
                'ListValue': { n: 'listValue', t: 2, f: 4 },
                'MapValue': { n: 'mapValue', r: 'search.NamedMap', r2: function () { return search.NamedMap; }, f: 5 }
            })
        ], AnnotationItem);
        return AnnotationItem;
    }(osa.base.Complex));
    search.AnnotationItem = AnnotationItem;
})(search || (search = {}));
(function (search) {
    var CollectionId = /** @class */ (function (_super) {
        __extends(CollectionId, _super);
        /**
        *
        * @param data - an initial data
        */
        function CollectionId(data) {
            return _super.call(this, data) || this;
        }
        CollectionId = __decorate([
            osa.decorators.ComplexType(search, 'search.CollectionId', {
                'Id': { n: 'id', t: 2 }
            })
        ], CollectionId);
        return CollectionId;
    }(osa.base.Complex));
    search.CollectionId = CollectionId;
})(search || (search = {}));
(function (search) {
    var CollectionInfo = /** @class */ (function (_super) {
        __extends(CollectionInfo, _super);
        /**
        *
        * @param data - an initial data
        */
        function CollectionInfo(data) {
            return _super.call(this, data) || this;
        }
        CollectionInfo = __decorate([
            osa.decorators.ComplexType(search, 'search.CollectionInfo', {
                'CollectionId': { n: 'collectionId', t: 2 },
                'Contact': { n: 'contact', t: 2 },
                'Created': { n: 'created', t: 2 },
                'Description': { n: 'description', t: 2 },
                'LastUpdate': { n: 'lastUpdate', t: 2 },
                'TotalDocCount': { n: 'totalDocCount', t: 10 },
                'IndexSize': { n: 'indexSize', t: 10 }
            })
        ], CollectionInfo);
        return CollectionInfo;
    }(osa.base.Complex));
    search.CollectionInfo = CollectionInfo;
})(search || (search = {}));
(function (search) {
    var ComplexFilter = /** @class */ (function (_super) {
        __extends(ComplexFilter, _super);
        /**
        *
        * @param data - an initial data
        */
        function ComplexFilter(data) {
            return _super.call(this, data) || this;
        }
        ComplexFilter = __decorate([
            osa.decorators.ComplexType(search, 'search.ComplexFilter', {
                'Operator': { n: 'operator', t: 4, r2: function () { return search.BooleanOperator; } },
                'Filters': { n: 'filters', r: 'search.FilterSpec', r2: function () { return search.FilterSpec; }, f: 5 }
            })
        ], ComplexFilter);
        return ComplexFilter;
    }(osa.base.Complex));
    search.ComplexFilter = ComplexFilter;
})(search || (search = {}));
(function (search) {
    var DocumentFragmentResult = /** @class */ (function (_super) {
        __extends(DocumentFragmentResult, _super);
        /**
        *
        * @param data - an initial data
        */
        function DocumentFragmentResult(data) {
            return _super.call(this, data) || this;
        }
        DocumentFragmentResult = __decorate([
            osa.decorators.ComplexType(search, 'search.DocumentFragmentResult', {
                'FragmentId': { n: 'fragmentId', t: 2 },
                'StartPosition': { n: 'startPosition', t: 10 },
                'EndPosition': { n: 'endPosition', t: 10 },
                'FragmentText': { n: 'fragmentText', t: 2 },
                'HitHighlights': { n: 'hitHighlights', r: 'search.HitHighlight', r2: function () { return search.HitHighlight; }, f: 5 },
                'FragmentAttributes': { n: 'fragmentAttributes', r: 'common.KeyValuePairList', r2: function () { return common.KeyValuePairList; }, f: 1 },
                'FragmentScore': { n: 'fragmentScore', t: 5 }
            })
        ], DocumentFragmentResult);
        return DocumentFragmentResult;
    }(osa.base.Complex));
    search.DocumentFragmentResult = DocumentFragmentResult;
})(search || (search = {}));
(function (search) {
    var DocumentId = /** @class */ (function (_super) {
        __extends(DocumentId, _super);
        /**
        *
        * @param data - an initial data
        */
        function DocumentId(data) {
            return _super.call(this, data) || this;
        }
        DocumentId = __decorate([
            osa.decorators.ComplexType(search, 'search.DocumentId', {
                'Id': { n: 'id', t: 2 }
            })
        ], DocumentId);
        return DocumentId;
    }(osa.base.Complex));
    search.DocumentId = DocumentId;
})(search || (search = {}));
(function (search) {
    var DocumentResult = /** @class */ (function (_super) {
        __extends(DocumentResult, _super);
        /**
        *
        * @param data - an initial data
        */
        function DocumentResult(data) {
            return _super.call(this, data) || this;
        }
        DocumentResult = __decorate([
            osa.decorators.ComplexType(search, 'search.DocumentResult', {
                'DocumentId': { n: 'documentId', t: 2 },
                'KwicSummary': { n: 'kwicSummary', t: 2 },
                'MimeType': { n: 'mimeType', t: 2 },
                'Score': { n: 'score', t: 5 },
                'FragmentsTotalHitCount': { n: 'fragmentsTotalHitCount', t: 9 },
                'DocumentProperties': { n: 'documentProperties', r: 'search.ResultField', r2: function () { return search.ResultField; }, f: 5 },
                'HitHighlights': { n: 'hitHighlights', r: 'search.HitHighlight', r2: function () { return search.HitHighlight; }, f: 5 },
                'DocumentFragments': { n: 'documentFragments', r: 'search.DocumentFragmentResult', r2: function () { return search.DocumentFragmentResult; }, f: 5 }
            })
        ], DocumentResult);
        return DocumentResult;
    }(osa.base.Complex));
    search.DocumentResult = DocumentResult;
})(search || (search = {}));
(function (search) {
    var DomainFilterExclusion = /** @class */ (function (_super) {
        __extends(DomainFilterExclusion, _super);
        /**
        *
        * @param data - an initial data
        */
        function DomainFilterExclusion(data) {
            return _super.call(this, data) || this;
        }
        DomainFilterExclusion = __decorate([
            osa.decorators.ComplexType(search, 'search.DomainFilterExclusion', {
                'FilterExclusionValues': { n: 'filterExclusionValues', t: 2, f: 4 }
            })
        ], DomainFilterExclusion);
        return DomainFilterExclusion;
    }(osa.base.Complex));
    search.DomainFilterExclusion = DomainFilterExclusion;
})(search || (search = {}));
(function (search) {
    var ExecuteQuery = /** @class */ (function (_super) {
        __extends(ExecuteQuery, _super);
        /**
        *
        * @param data - an initial data
        */
        function ExecuteQuery(data) {
            return _super.call(this, data) || this;
        }
        ExecuteQuery = __decorate([
            osa.decorators.ComplexType(search, 'search.ExecuteQuery', {
                'QueryString': { n: 'queryString', t: 2 },
                'HighlightQueryString': { n: 'highlightQueryString', t: 2 },
                'CollectionId': { n: 'collectionId', t: 2 },
                'MasterCollection': { n: 'masterCollection', t: 2 },
                'Query': { n: 'query', r: 'search.QuerySpec', r2: function () { return search.QuerySpec; }, f: 1 },
                'FragmentDocument': { n: 'fragmentDocument', t: 4, r2: function () { return search.FragmentStyle; } },
                'HighlightingEnabled': { n: 'highlightingEnabled', t: 1 },
                'PropertyValues': { n: 'propertyValues', r: 'common.KeyValuePairList', r2: function () { return common.KeyValuePairList; }, f: 1 }
            })
        ], ExecuteQuery);
        return ExecuteQuery;
    }(osa.base.Complex));
    search.ExecuteQuery = ExecuteQuery;
})(search || (search = {}));
(function (search) {
    var ExecuteQueryFromTree = /** @class */ (function (_super) {
        __extends(ExecuteQueryFromTree, _super);
        /**
        *
        * @param data - an initial data
        */
        function ExecuteQueryFromTree(data) {
            return _super.call(this, data) || this;
        }
        ExecuteQueryFromTree = __decorate([
            osa.decorators.ComplexType(search, 'search.ExecuteQueryFromTree', {
                'QueryTree': { n: 'queryTree', r: 'search.ParseTreeNode', r2: function () { return search.ParseTreeNode; }, f: 1 },
                'HighlightQueryTree': { n: 'highlightQueryTree', r: 'search.ParseTreeNode', r2: function () { return search.ParseTreeNode; }, f: 1 },
                'CollectionId': { n: 'collectionId', t: 2 },
                'MasterCollection': { n: 'masterCollection', t: 2 },
                'Query': { n: 'query', r: 'search.QuerySpec', r2: function () { return search.QuerySpec; }, f: 1 },
                'FragmentDocument': { n: 'fragmentDocument', t: 4, r2: function () { return search.FragmentStyle; } },
                'HighlightingEnabled': { n: 'highlightingEnabled', t: 1 },
                'PropertyValues': { n: 'propertyValues', r: 'common.KeyValuePairList', r2: function () { return common.KeyValuePairList; }, f: 1 }
            })
        ], ExecuteQueryFromTree);
        return ExecuteQueryFromTree;
    }(osa.base.Complex));
    search.ExecuteQueryFromTree = ExecuteQueryFromTree;
})(search || (search = {}));
(function (search) {
    var ExecuteQueryFromTreeResponse = /** @class */ (function (_super) {
        __extends(ExecuteQueryFromTreeResponse, _super);
        /**
        *
        * @param data - an initial data
        */
        function ExecuteQueryFromTreeResponse(data) {
            return _super.call(this, data) || this;
        }
        ExecuteQueryFromTreeResponse = __decorate([
            osa.decorators.ComplexType(search, 'search.ExecuteQueryFromTreeResponse', {
                'Rows': { n: 'rows', t: 9 },
                'QueryTime': { n: 'queryTime', t: 10 },
                'Grouped': { n: 'grouped', t: 1 },
                'NumGroups': { n: 'numGroups', t: 9 },
                'Results': { n: 'results', r: 'search.ResultGroup', r2: function () { return search.ResultGroup; }, f: 5 },
                'Facets': { n: 'facets', r: 'search.FacetGroup', r2: function () { return search.FacetGroup; }, f: 5 },
                'AdvancedFacets': { n: 'advancedFacets', r: 'search.AdvancedFacetGroup', r2: function () { return search.AdvancedFacetGroup; }, f: 5 }
            })
        ], ExecuteQueryFromTreeResponse);
        return ExecuteQueryFromTreeResponse;
    }(osa.base.Complex));
    search.ExecuteQueryFromTreeResponse = ExecuteQueryFromTreeResponse;
})(search || (search = {}));
(function (search) {
    var ExecuteQueryResponse = /** @class */ (function (_super) {
        __extends(ExecuteQueryResponse, _super);
        /**
        *
        * @param data - an initial data
        */
        function ExecuteQueryResponse(data) {
            return _super.call(this, data) || this;
        }
        ExecuteQueryResponse = __decorate([
            osa.decorators.ComplexType(search, 'search.ExecuteQueryResponse', {
                'Rows': { n: 'rows', t: 9 },
                'QueryTime': { n: 'queryTime', t: 10 },
                'Grouped': { n: 'grouped', t: 1 },
                'NumGroups': { n: 'numGroups', t: 9 },
                'Results': { n: 'results', r: 'search.ResultGroup', r2: function () { return search.ResultGroup; }, f: 5 },
                'Facets': { n: 'facets', r: 'search.FacetGroup', r2: function () { return search.FacetGroup; }, f: 5 },
                'AdvancedFacets': { n: 'advancedFacets', r: 'search.AdvancedFacetGroup', r2: function () { return search.AdvancedFacetGroup; }, f: 5 },
                'QueryAdjustments': { n: 'queryAdjustments', r: 'search.QueryAdjustment', r2: function () { return search.QueryAdjustment; }, f: 5 },
                'Suggestions': { n: 'suggestions', r: 'search.SpellingSuggestions', r2: function () { return search.SpellingSuggestions; }, f: 1 }
            })
        ], ExecuteQueryResponse);
        return ExecuteQueryResponse;
    }(osa.base.Complex));
    search.ExecuteQueryResponse = ExecuteQueryResponse;
})(search || (search = {}));
(function (search) {
    var FacetGroup = /** @class */ (function (_super) {
        __extends(FacetGroup, _super);
        /**
        *
        * @param data - an initial data
        */
        function FacetGroup(data) {
            return _super.call(this, data) || this;
        }
        FacetGroup = __decorate([
            osa.decorators.ComplexType(search, 'search.FacetGroup', {
                'FieldName': { n: 'fieldName', t: 2 },
                'FacetResults': { n: 'facetResults', r: 'search.FacetResult', r2: function () { return search.FacetResult; }, f: 5 }
            })
        ], FacetGroup);
        return FacetGroup;
    }(osa.base.Complex));
    search.FacetGroup = FacetGroup;
})(search || (search = {}));
(function (search) {
    var FacetResult = /** @class */ (function (_super) {
        __extends(FacetResult, _super);
        /**
        *
        * @param data - an initial data
        */
        function FacetResult(data) {
            return _super.call(this, data) || this;
        }
        FacetResult = __decorate([
            osa.decorators.ComplexType(search, 'search.FacetResult', {
                'Label': { n: 'label', t: 2 },
                'HitCount': { n: 'hitCount', t: 10 }
            })
        ], FacetResult);
        return FacetResult;
    }(osa.base.Complex));
    search.FacetResult = FacetResult;
})(search || (search = {}));
(function (search) {
    var FacetSpec = /** @class */ (function (_super) {
        __extends(FacetSpec, _super);
        /**
        *
        * @param data - an initial data
        */
        function FacetSpec(data) {
            return _super.call(this, data) || this;
        }
        FacetSpec = __decorate([
            osa.decorators.ComplexType(search, 'search.FacetSpec', {
                'FacetType': { n: 'facetType', t: 4, r2: function () { return search.FacetSpecType; } },
                'FieldName': { n: 'fieldName', t: 2 },
                'MinCount': { n: 'minCount', t: 9 },
                'FacetByField': { n: 'facetByField', r: 'search.FieldFacet', r2: function () { return search.FieldFacet; }, f: 1 },
                'FacetByNumericRange': { n: 'facetByNumericRange', r: 'search.RangeFacet', r2: function () { return search.RangeFacet; }, f: 1 },
                'FacetByHierarchy': { n: 'facetByHierarchy', r: 'search.HierarchyFacet', r2: function () { return search.HierarchyFacet; }, f: 1 },
                'ExcludeFilters': { n: 'excludeFilters', t: 2, f: 4 }
            })
        ], FacetSpec);
        return FacetSpec;
    }(osa.base.Complex));
    search.FacetSpec = FacetSpec;
})(search || (search = {}));
(function (search) {
    var FieldFacet = /** @class */ (function (_super) {
        __extends(FieldFacet, _super);
        /**
        *
        * @param data - an initial data
        */
        function FieldFacet(data) {
            return _super.call(this, data) || this;
        }
        FieldFacet = __decorate([
            osa.decorators.ComplexType(search, 'search.FieldFacet', {
                'Prefix': { n: 'prefix', t: 2 },
                'Sort': { n: 'sort', t: 4, r2: function () { return search.FacetSortType; } },
                'Limit': { n: 'limit', t: 9 },
                'Offset': { n: 'offset', t: 9 },
                'IncludeMissingFacetCount': { n: 'includeMissingFacetCount', t: 1 }
            })
        ], FieldFacet);
        return FieldFacet;
    }(osa.base.Complex));
    search.FieldFacet = FieldFacet;
})(search || (search = {}));
(function (search) {
    var FilterSpec = /** @class */ (function (_super) {
        __extends(FilterSpec, _super);
        /**
        *
        * @param data - an initial data
        */
        function FilterSpec(data) {
            return _super.call(this, data) || this;
        }
        FilterSpec = __decorate([
            osa.decorators.ComplexType(search, 'search.FilterSpec', {
                'FilterType': { n: 'filterType', t: 4, r2: function () { return search.FilterSpecType; } },
                'ExclusionFilter': { n: 'exclusionFilter', t: 1 },
                'FilterByTerms': { n: 'filterByTerms', r: 'search.TermsFilter', r2: function () { return search.TermsFilter; }, f: 1 },
                'FilterByNumericRange': { n: 'filterByNumericRange', r: 'search.RangeFilter', r2: function () { return search.RangeFilter; }, f: 1 },
                'FilterByQuery': { n: 'filterByQuery', r: 'search.QueryFilter', r2: function () { return search.QueryFilter; }, f: 1 },
                'ComplexFilter': { n: 'complexFilter', r: 'search.ComplexFilter', r2: function () { return search.ComplexFilter; }, f: 1 },
                'NoValueFilter': { n: 'noValueFilter', r: 'search.NoValueFilter', r2: function () { return search.NoValueFilter; }, f: 1 }
            })
        ], FilterSpec);
        return FilterSpec;
    }(osa.base.Complex));
    search.FilterSpec = FilterSpec;
})(search || (search = {}));
(function (search) {
    var GroupingFilterSpec = /** @class */ (function (_super) {
        __extends(GroupingFilterSpec, _super);
        /**
        *
        * @param data - an initial data
        */
        function GroupingFilterSpec(data) {
            return _super.call(this, data) || this;
        }
        GroupingFilterSpec = __decorate([
            osa.decorators.ComplexType(search, 'search.GroupingFilterSpec', {
                'FilterGroups': { n: 'filterGroups', r: 'search.FilterSpec', r2: function () { return search.FilterSpec; }, f: 5 }
            })
        ], GroupingFilterSpec);
        return GroupingFilterSpec;
    }(osa.base.Complex));
    search.GroupingFilterSpec = GroupingFilterSpec;
})(search || (search = {}));
(function (search) {
    var GroupingSpec = /** @class */ (function (_super) {
        __extends(GroupingSpec, _super);
        /**
        *
        * @param data - an initial data
        */
        function GroupingSpec(data) {
            return _super.call(this, data) || this;
        }
        GroupingSpec = __decorate([
            osa.decorators.ComplexType(search, 'search.GroupingSpec', {
                'Rows': { n: 'rows', t: 9 },
                'Start': { n: 'start', t: 9 },
                'Sort': { n: 'sort', r: 'search.ResultSort', r2: function () { return search.ResultSort; }, f: 5 },
                'FieldName': { n: 'fieldName', t: 2 }
            })
        ], GroupingSpec);
        return GroupingSpec;
    }(osa.base.Complex));
    search.GroupingSpec = GroupingSpec;
})(search || (search = {}));
(function (search) {
    var HierarchyFacet = /** @class */ (function (_super) {
        __extends(HierarchyFacet, _super);
        /**
        *
        * @param data - an initial data
        */
        function HierarchyFacet(data) {
            return _super.call(this, data) || this;
        }
        HierarchyFacet = __decorate([
            osa.decorators.ComplexType(search, 'search.HierarchyFacet', {
                'Prefix': { n: 'prefix', t: 2 },
                'Sort': { n: 'sort', t: 4, r2: function () { return search.FacetSortType; } },
                'Limit': { n: 'limit', t: 9 },
                'Offset': { n: 'offset', t: 9 },
                'IncludeMissingFacetCount': { n: 'includeMissingFacetCount', t: 1 },
                'FromLevel': { n: 'fromLevel', t: 9 },
                'ToLevel': { n: 'toLevel', t: 9 }
            })
        ], HierarchyFacet);
        return HierarchyFacet;
    }(osa.base.Complex));
    search.HierarchyFacet = HierarchyFacet;
})(search || (search = {}));
(function (search) {
    var HighlightDocument = /** @class */ (function (_super) {
        __extends(HighlightDocument, _super);
        /**
        *
        * @param data - an initial data
        */
        function HighlightDocument(data) {
            return _super.call(this, data) || this;
        }
        HighlightDocument = __decorate([
            osa.decorators.ComplexType(search, 'search.HighlightDocument', {
                'QueryString': { n: 'queryString', t: 2 },
                'CollectionId': { n: 'collectionId', t: 2 },
                'MasterCollection': { n: 'masterCollection', t: 2 },
                'Query': { n: 'query', r: 'search.QuerySpec', r2: function () { return search.QuerySpec; }, f: 1 },
                'HitHighlightsAsOffsets': { n: 'hitHighlightsAsOffsets', t: 1 },
                'FragmentDocument': { n: 'fragmentDocument', t: 4, r2: function () { return search.FragmentStyle; } },
                'ReturnDocumentText': { n: 'returnDocumentText', t: 1 },
                'PropertyValues': { n: 'propertyValues', r: 'common.KeyValuePairList', r2: function () { return common.KeyValuePairList; }, f: 1 },
                'DocumentIds': { n: 'documentIds', t: 2, f: 4 }
            })
        ], HighlightDocument);
        return HighlightDocument;
    }(osa.base.Complex));
    search.HighlightDocument = HighlightDocument;
})(search || (search = {}));
(function (search) {
    var HighlightDocumentFromTree = /** @class */ (function (_super) {
        __extends(HighlightDocumentFromTree, _super);
        /**
        *
        * @param data - an initial data
        */
        function HighlightDocumentFromTree(data) {
            return _super.call(this, data) || this;
        }
        HighlightDocumentFromTree = __decorate([
            osa.decorators.ComplexType(search, 'search.HighlightDocumentFromTree', {
                'QueryTree': { n: 'queryTree', r: 'search.ParseTreeNode', r2: function () { return search.ParseTreeNode; }, f: 1 },
                'CollectionId': { n: 'collectionId', t: 2 },
                'MasterCollection': { n: 'masterCollection', t: 2 },
                'Query': { n: 'query', r: 'search.QuerySpec', r2: function () { return search.QuerySpec; }, f: 1 },
                'HitHighlightsAsOffsets': { n: 'hitHighlightsAsOffsets', t: 1 },
                'FragmentDocument': { n: 'fragmentDocument', t: 4, r2: function () { return search.FragmentStyle; } },
                'ReturnDocumentText': { n: 'returnDocumentText', t: 1 },
                'PropertyValues': { n: 'propertyValues', r: 'common.KeyValuePairList', r2: function () { return common.KeyValuePairList; }, f: 1 },
                'DocumentIds': { n: 'documentIds', t: 2, f: 4 }
            })
        ], HighlightDocumentFromTree);
        return HighlightDocumentFromTree;
    }(osa.base.Complex));
    search.HighlightDocumentFromTree = HighlightDocumentFromTree;
})(search || (search = {}));
(function (search) {
    var HighlightDocumentFromTreeResponse = /** @class */ (function (_super) {
        __extends(HighlightDocumentFromTreeResponse, _super);
        /**
        *
        * @param data - an initial data
        */
        function HighlightDocumentFromTreeResponse(data) {
            return _super.call(this, data) || this;
        }
        HighlightDocumentFromTreeResponse = __decorate([
            osa.decorators.ComplexType(search, 'search.HighlightDocumentFromTreeResponse', {
                'QueryTime': { n: 'queryTime', t: 10 },
                'Results': { n: 'results', r: 'search.ResultGroup', r2: function () { return search.ResultGroup; }, f: 5 }
            })
        ], HighlightDocumentFromTreeResponse);
        return HighlightDocumentFromTreeResponse;
    }(osa.base.Complex));
    search.HighlightDocumentFromTreeResponse = HighlightDocumentFromTreeResponse;
})(search || (search = {}));
(function (search) {
    var HighlightDocumentResponse = /** @class */ (function (_super) {
        __extends(HighlightDocumentResponse, _super);
        /**
        *
        * @param data - an initial data
        */
        function HighlightDocumentResponse(data) {
            return _super.call(this, data) || this;
        }
        HighlightDocumentResponse = __decorate([
            osa.decorators.ComplexType(search, 'search.HighlightDocumentResponse', {
                'QueryTime': { n: 'queryTime', t: 10 },
                'Results': { n: 'results', r: 'search.ResultGroup', r2: function () { return search.ResultGroup; }, f: 5 }
            })
        ], HighlightDocumentResponse);
        return HighlightDocumentResponse;
    }(osa.base.Complex));
    search.HighlightDocumentResponse = HighlightDocumentResponse;
})(search || (search = {}));
(function (search) {
    var HighlightText = /** @class */ (function (_super) {
        __extends(HighlightText, _super);
        /**
        *
        * @param data - an initial data
        */
        function HighlightText(data) {
            return _super.call(this, data) || this;
        }
        HighlightText = __decorate([
            osa.decorators.ComplexType(search, 'search.HighlightText', {
                'QueryString': { n: 'queryString', t: 2 },
                'CollectionId': { n: 'collectionId', t: 2 },
                'MasterCollection': { n: 'masterCollection', t: 2 },
                'Query': { n: 'query', r: 'search.QuerySpec', r2: function () { return search.QuerySpec; }, f: 1 },
                'HitHighlightsAsOffsets': { n: 'hitHighlightsAsOffsets', t: 1 },
                'PropertyValues': { n: 'propertyValues', r: 'common.KeyValuePairList', r2: function () { return common.KeyValuePairList; }, f: 1 },
                'Text': { n: 'text', t: 2 }
            })
        ], HighlightText);
        return HighlightText;
    }(osa.base.Complex));
    search.HighlightText = HighlightText;
})(search || (search = {}));
(function (search) {
    var HighlightTextFromTree = /** @class */ (function (_super) {
        __extends(HighlightTextFromTree, _super);
        /**
        *
        * @param data - an initial data
        */
        function HighlightTextFromTree(data) {
            return _super.call(this, data) || this;
        }
        HighlightTextFromTree = __decorate([
            osa.decorators.ComplexType(search, 'search.HighlightTextFromTree', {
                'QueryTree': { n: 'queryTree', r: 'search.ParseTreeNode', r2: function () { return search.ParseTreeNode; }, f: 1 },
                'CollectionId': { n: 'collectionId', t: 2 },
                'MasterCollection': { n: 'masterCollection', t: 2 },
                'Query': { n: 'query', r: 'search.QuerySpec', r2: function () { return search.QuerySpec; }, f: 1 },
                'HitHighlightsAsOffsets': { n: 'hitHighlightsAsOffsets', t: 1 },
                'PropertyValues': { n: 'propertyValues', r: 'common.KeyValuePairList', r2: function () { return common.KeyValuePairList; }, f: 1 },
                'Text': { n: 'text', t: 2 }
            })
        ], HighlightTextFromTree);
        return HighlightTextFromTree;
    }(osa.base.Complex));
    search.HighlightTextFromTree = HighlightTextFromTree;
})(search || (search = {}));
(function (search) {
    var HighlightTextFromTreeResponse = /** @class */ (function (_super) {
        __extends(HighlightTextFromTreeResponse, _super);
        /**
        *
        * @param data - an initial data
        */
        function HighlightTextFromTreeResponse(data) {
            return _super.call(this, data) || this;
        }
        HighlightTextFromTreeResponse = __decorate([
            osa.decorators.ComplexType(search, 'search.HighlightTextFromTreeResponse', {
                'QueryTime': { n: 'queryTime', t: 10 },
                'Results': { n: 'results', r: 'search.ResultGroup', r2: function () { return search.ResultGroup; }, f: 5 }
            })
        ], HighlightTextFromTreeResponse);
        return HighlightTextFromTreeResponse;
    }(osa.base.Complex));
    search.HighlightTextFromTreeResponse = HighlightTextFromTreeResponse;
})(search || (search = {}));
(function (search) {
    var HighlightTextResponse = /** @class */ (function (_super) {
        __extends(HighlightTextResponse, _super);
        /**
        *
        * @param data - an initial data
        */
        function HighlightTextResponse(data) {
            return _super.call(this, data) || this;
        }
        HighlightTextResponse = __decorate([
            osa.decorators.ComplexType(search, 'search.HighlightTextResponse', {
                'QueryTime': { n: 'queryTime', t: 10 },
                'Results': { n: 'results', r: 'search.ResultGroup', r2: function () { return search.ResultGroup; }, f: 5 }
            })
        ], HighlightTextResponse);
        return HighlightTextResponse;
    }(osa.base.Complex));
    search.HighlightTextResponse = HighlightTextResponse;
})(search || (search = {}));
(function (search) {
    var HitHighlight = /** @class */ (function (_super) {
        __extends(HitHighlight, _super);
        /**
        *
        * @param data - an initial data
        */
        function HitHighlight(data) {
            return _super.call(this, data) || this;
        }
        HitHighlight = __decorate([
            osa.decorators.ComplexType(search, 'search.HitHighlight', {
                'StartPosition': { n: 'startPosition', t: 10 },
                'EndPosition': { n: 'endPosition', t: 10 },
                'Term': { n: 'term', t: 2 },
                'FieldName': { n: 'fieldName', t: 2 }
            })
        ], HitHighlight);
        return HitHighlight;
    }(osa.base.Complex));
    search.HitHighlight = HitHighlight;
})(search || (search = {}));
(function (search) {
    var Imports = /** @class */ (function (_super) {
        __extends(Imports, _super);
        /**
        *
        * @param data - an initial data
        */
        function Imports(data) {
            return _super.call(this, data) || this;
        }
        Imports = __decorate([
            osa.decorators.ComplexType(search, 'search.Imports', {
                'CollectionIds': { n: 'collectionIds', t: 2, f: 4 },
                'PackageIds': { n: 'packageIds', t: 2, f: 4 },
                'Start': { n: 'start', t: 9 },
                'Rows': { n: 'rows', t: 9 },
                'FromDate': { n: 'fromDate', t: 2 },
                'ToDate': { n: 'toDate', t: 2 },
                'PackageStatuses': { n: 'packageStatuses', t: 4, r2: function () { return search.PackageStatus; }, f: 4 },
                'PackageTypes': { n: 'packageTypes', t: 4, r2: function () { return search.PackageType; }, f: 4 }
            })
        ], Imports);
        return Imports;
    }(osa.base.Complex));
    search.Imports = Imports;
})(search || (search = {}));
(function (search) {
    var NamedMap = /** @class */ (function (_super) {
        __extends(NamedMap, _super);
        /**
        *
        * @param data - an initial data
        */
        function NamedMap(data) {
            return _super.call(this, data) || this;
        }
        NamedMap = __decorate([
            osa.decorators.ComplexType(search, 'search.NamedMap', {
                'MapName': { n: 'mapName', t: 2 },
                'Annotations': { n: 'annotations', r: 'search.AnnotationItem', r2: function () { return search.AnnotationItem; }, f: 5 }
            })
        ], NamedMap);
        return NamedMap;
    }(osa.base.Complex));
    search.NamedMap = NamedMap;
})(search || (search = {}));
(function (search) {
    var NoValueFilter = /** @class */ (function (_super) {
        __extends(NoValueFilter, _super);
        /**
        *
        * @param data - an initial data
        */
        function NoValueFilter(data) {
            return _super.call(this, data) || this;
        }
        NoValueFilter = __decorate([
            osa.decorators.ComplexType(search, 'search.NoValueFilter', {
                'FieldName': { n: 'fieldName', t: 2 }
            })
        ], NoValueFilter);
        return NoValueFilter;
    }(osa.base.Complex));
    search.NoValueFilter = NoValueFilter;
})(search || (search = {}));
(function (search) {
    var NumericValueRange = /** @class */ (function (_super) {
        __extends(NumericValueRange, _super);
        /**
        *
        * @param data - an initial data
        */
        function NumericValueRange(data) {
            return _super.call(this, data) || this;
        }
        NumericValueRange = __decorate([
            osa.decorators.ComplexType(search, 'search.NumericValueRange', {
                'LowerBound': { n: 'lowerBound', t: 2 },
                'UpperBound': { n: 'upperBound', t: 2 },
                'RangeName': { n: 'rangeName', t: 2 }
            })
        ], NumericValueRange);
        return NumericValueRange;
    }(osa.base.Complex));
    search.NumericValueRange = NumericValueRange;
})(search || (search = {}));
(function (search) {
    var PackageInfo = /** @class */ (function (_super) {
        __extends(PackageInfo, _super);
        /**
        *
        * @param data - an initial data
        */
        function PackageInfo(data) {
            return _super.call(this, data) || this;
        }
        PackageInfo = __decorate([
            osa.decorators.ComplexType(search, 'search.PackageInfo', {
                'PackageId': { n: 'packageId', t: 2 },
                'CollectionId': { n: 'collectionId', t: 2 },
                'CorrelationId': { n: 'correlationId', t: 2 },
                'Created': { n: 'created', t: 2 },
                'Received': { n: 'received', t: 2 },
                'LastActivity': { n: 'lastActivity', t: 2 },
                'PackageType': { n: 'packageType', t: 4, r2: function () { return search.PackageType; } },
                'Status': { n: 'status', t: 4, r2: function () { return search.PackageStatus; } },
                'DocsProcessed': { n: 'docsProcessed', t: 9 },
                'DocsDeleted': { n: 'docsDeleted', t: 9 },
                'DocsIndexed': { n: 'docsIndexed', t: 9 },
                'ValidationErrors': { n: 'validationErrors', t: 9 },
                'IndexingErrors': { n: 'indexingErrors', t: 9 },
                'Contact': { n: 'contact', t: 2 },
                'PackageFile': { n: 'packageFile', t: 2 },
                'Messages': { n: 'messages', t: 2 },
                'IsRefreshPackage': { n: 'isRefreshPackage', t: 1 },
                'IsCleanCollection': { n: 'isCleanCollection', t: 1 }
            })
        ], PackageInfo);
        return PackageInfo;
    }(osa.base.Complex));
    search.PackageInfo = PackageInfo;
})(search || (search = {}));
(function (search) {
    var ParseTreeAnnotation = /** @class */ (function (_super) {
        __extends(ParseTreeAnnotation, _super);
        /**
        *
        * @param data - an initial data
        */
        function ParseTreeAnnotation(data) {
            return _super.call(this, data) || this;
        }
        ParseTreeAnnotation = __decorate([
            osa.decorators.ComplexType(search, 'search.ParseTreeAnnotation', {
                'AnalyzerId': { n: 'analyzerId', t: 2 },
                'Annotation': { n: 'annotation', r: 'search.AnnotationItem', r2: function () { return search.AnnotationItem; }, f: 5 }
            })
        ], ParseTreeAnnotation);
        return ParseTreeAnnotation;
    }(osa.base.Complex));
    search.ParseTreeAnnotation = ParseTreeAnnotation;
})(search || (search = {}));
(function (search) {
    var ParseTreeNode = /** @class */ (function (_super) {
        __extends(ParseTreeNode, _super);
        /**
        *
        * @param data - an initial data
        */
        function ParseTreeNode(data) {
            return _super.call(this, data) || this;
        }
        ParseTreeNode = __decorate([
            osa.decorators.ComplexType(search, 'search.ParseTreeNode', {
                'Type': { n: 'type', t: 4, r2: function () { return search.NodeType; } },
                'StartPosition': { n: 'startPosition', t: 9 },
                'EndPosition': { n: 'endPosition', t: 9 },
                'NodeImage': { n: 'nodeImage', t: 2 },
                'Annotations': { n: 'annotations', r: 'search.ParseTreeAnnotation', r2: function () { return search.ParseTreeAnnotation; }, f: 5 },
                'Children': { n: 'children', r: 'search.ParseTreeNode', r2: function () { return search.ParseTreeNode; }, f: 5 }
            })
        ], ParseTreeNode);
        return ParseTreeNode;
    }(osa.base.Complex));
    search.ParseTreeNode = ParseTreeNode;
})(search || (search = {}));
(function (search) {
    var PassThruParam = /** @class */ (function (_super) {
        __extends(PassThruParam, _super);
        /**
        *
        * @param data - an initial data
        */
        function PassThruParam(data) {
            return _super.call(this, data) || this;
        }
        PassThruParam = __decorate([
            osa.decorators.ComplexType(search, 'search.PassThruParam', {
                'TemplateName': { n: 'templateName', t: 2 },
                'NamedParams': { n: 'namedParams', r: 'common.KeyValuePairList', r2: function () { return common.KeyValuePairList; }, f: 1 }
            })
        ], PassThruParam);
        return PassThruParam;
    }(osa.base.Complex));
    search.PassThruParam = PassThruParam;
})(search || (search = {}));
(function (search) {
    var PitSearchSpec = /** @class */ (function (_super) {
        __extends(PitSearchSpec, _super);
        /**
        *
        * @param data - an initial data
        */
        function PitSearchSpec(data) {
            return _super.call(this, data) || this;
        }
        PitSearchSpec = __decorate([
            osa.decorators.ComplexType(search, 'search.PitSearchSpec', {
                'ResearchDate': { n: 'researchDate', t: 2 },
                'StartDateFieldName': { n: 'startDateFieldName', t: 2 },
                'EndDateFieldName': { n: 'endDateFieldName', t: 2 },
                'ExclusionFilter': { n: 'exclusionFilter', t: 1 }
            })
        ], PitSearchSpec);
        return PitSearchSpec;
    }(osa.base.Complex));
    search.PitSearchSpec = PitSearchSpec;
})(search || (search = {}));
(function (search) {
    var PropertyValue = /** @class */ (function (_super) {
        __extends(PropertyValue, _super);
        /**
        *
        * @param data - an initial data
        */
        function PropertyValue(data) {
            return _super.call(this, data) || this;
        }
        PropertyValue = __decorate([
            osa.decorators.ComplexType(search, 'search.PropertyValue', {
                'Name': { n: 'name', t: 2 },
                'Value': { n: 'value', t: 2 },
                'Type': { n: 'type', t: 4, r2: function () { return search.FieldType; } },
                'MimeType': { n: 'mimeType', t: 2 }
            })
        ], PropertyValue);
        return PropertyValue;
    }(osa.base.Complex));
    search.PropertyValue = PropertyValue;
})(search || (search = {}));
(function (search) {
    var QueryAdjustment = /** @class */ (function (_super) {
        __extends(QueryAdjustment, _super);
        /**
        *
        * @param data - an initial data
        */
        function QueryAdjustment(data) {
            return _super.call(this, data) || this;
        }
        QueryAdjustment = __decorate([
            osa.decorators.ComplexType(search, 'search.QueryAdjustment', {
                'QueryPart': { n: 'queryPart', r: 'search.QueryPart', r2: function () { return search.QueryPart; }, f: 1 },
                'AdjustmentType': { n: 'adjustmentType', t: 4, r2: function () { return search.AdjustmentType; } },
                'AdjustmentMetadata': { n: 'adjustmentMetadata', r: 'common.KeyValuePair', r2: function () { return common.KeyValuePair; }, f: 5 },
                'Applied': { n: 'applied', t: 1 }
            })
        ], QueryAdjustment);
        return QueryAdjustment;
    }(osa.base.Complex));
    search.QueryAdjustment = QueryAdjustment;
})(search || (search = {}));
(function (search) {
    var QueryFilter = /** @class */ (function (_super) {
        __extends(QueryFilter, _super);
        /**
        *
        * @param data - an initial data
        */
        function QueryFilter(data) {
            return _super.call(this, data) || this;
        }
        QueryFilter = __decorate([
            osa.decorators.ComplexType(search, 'search.QueryFilter', {
                'QueryString': { n: 'queryString', t: 2 },
                'AnalyzeQuery': { n: 'analyzeQuery', t: 1 }
            })
        ], QueryFilter);
        return QueryFilter;
    }(osa.base.Complex));
    search.QueryFilter = QueryFilter;
})(search || (search = {}));
(function (search) {
    var QueryPart = /** @class */ (function (_super) {
        __extends(QueryPart, _super);
        /**
        *
        * @param data - an initial data
        */
        function QueryPart(data) {
            return _super.call(this, data) || this;
        }
        QueryPart = __decorate([
            osa.decorators.ComplexType(search, 'search.QueryPart', {
                'QueryPartId': { n: 'queryPartId', t: 2 },
                'Text': { n: 'text', t: 2 },
                'Start': { n: 'start', t: 9 },
                'Length': { n: 'length', t: 9 }
            })
        ], QueryPart);
        return QueryPart;
    }(osa.base.Complex));
    search.QueryPart = QueryPart;
})(search || (search = {}));
(function (search) {
    var QueryProcessingSpec = /** @class */ (function (_super) {
        __extends(QueryProcessingSpec, _super);
        /**
        *
        * @param data - an initial data
        */
        function QueryProcessingSpec(data) {
            return _super.call(this, data) || this;
        }
        QueryProcessingSpec = __decorate([
            osa.decorators.ComplexType(search, 'search.QueryProcessingSpec', {
                'QueryLanguage': { n: 'queryLanguage', t: 2 },
                'DefaultOperator': { n: 'defaultOperator', t: 4, r2: function () { return search.BooleanOperator; } },
                'DefaultSearchFieldsWithBoosts': { n: 'defaultSearchFieldsWithBoosts', r: 'common.KeyValuePairList', r2: function () { return common.KeyValuePairList; }, f: 1 },
                'FieldedSearchTranslations': { n: 'fieldedSearchTranslations', r: 'common.KeyValuePairList', r2: function () { return common.KeyValuePairList; }, f: 1 },
                'PassthruParams': { n: 'passthruParams', r: 'search.PassThruParam', r2: function () { return search.PassThruParam; }, f: 5 },
                'RemoveStopwords': { n: 'removeStopwords', t: 1 },
                'ApplySynonymExpansion': { n: 'applySynonymExpansion', t: 1 },
                'QueryAdjustments': { n: 'queryAdjustments', r: 'search.QueryAdjustment', r2: function () { return search.QueryAdjustment; }, f: 5 }
            })
        ], QueryProcessingSpec);
        return QueryProcessingSpec;
    }(osa.base.Complex));
    search.QueryProcessingSpec = QueryProcessingSpec;
})(search || (search = {}));
(function (search) {
    var QuerySpec = /** @class */ (function (_super) {
        __extends(QuerySpec, _super);
        /**
        *
        * @param data - an initial data
        */
        function QuerySpec(data) {
            return _super.call(this, data) || this;
        }
        QuerySpec = __decorate([
            osa.decorators.ComplexType(search, 'search.QuerySpec', {
                'FilterSpecs': { n: 'filterSpecs', r: 'search.FilterSpec', r2: function () { return search.FilterSpec; }, f: 5 },
                'FacetSpecs': { n: 'facetSpecs', r: 'search.FacetSpec', r2: function () { return search.FacetSpec; }, f: 5 },
                'AdvFacetSpecs': { n: 'advFacetSpecs', r: 'search.AdvancedFacetSpec', r2: function () { return search.AdvancedFacetSpec; }, f: 5 },
                'ResultSpec': { n: 'resultSpec', r: 'search.ResultSpec', r2: function () { return search.ResultSpec; }, f: 1 },
                'QueryProcessingSpec': { n: 'queryProcessingSpec', r: 'search.QueryProcessingSpec', r2: function () { return search.QueryProcessingSpec; }, f: 1 },
                'FuzzySearch': { n: 'fuzzySearch', t: 1 },
                'SpellSpec': { n: 'spellSpec', r: 'search.SpellSpec', r2: function () { return search.SpellSpec; }, f: 1 },
                'PitSearchSpecs': { n: 'pitSearchSpecs', r: 'search.PitSearchSpec', r2: function () { return search.PitSearchSpec; }, f: 5 }
            })
        ], QuerySpec);
        return QuerySpec;
    }(osa.base.Complex));
    search.QuerySpec = QuerySpec;
})(search || (search = {}));
(function (search) {
    var RangeFacet = /** @class */ (function (_super) {
        __extends(RangeFacet, _super);
        /**
        *
        * @param data - an initial data
        */
        function RangeFacet(data) {
            return _super.call(this, data) || this;
        }
        RangeFacet = __decorate([
            osa.decorators.ComplexType(search, 'search.RangeFacet', {
                'ValueType': { n: 'valueType', t: 4, r2: function () { return search.FieldType; } },
                'Range': { n: 'range', r: 'search.NumericValueRange', r2: function () { return search.NumericValueRange; }, f: 5 }
            })
        ], RangeFacet);
        return RangeFacet;
    }(osa.base.Complex));
    search.RangeFacet = RangeFacet;
})(search || (search = {}));
(function (search) {
    var RangeFilter = /** @class */ (function (_super) {
        __extends(RangeFilter, _super);
        /**
        *
        * @param data - an initial data
        */
        function RangeFilter(data) {
            return _super.call(this, data) || this;
        }
        RangeFilter = __decorate([
            osa.decorators.ComplexType(search, 'search.RangeFilter', {
                'FieldName': { n: 'fieldName', t: 2 },
                'ValueType': { n: 'valueType', t: 4, r2: function () { return search.FieldType; } },
                'RangeStartValue': { n: 'rangeStartValue', t: 2 },
                'RangeEndValue': { n: 'rangeEndValue', t: 2 },
                'IncludeStartValue': { n: 'includeStartValue', t: 1 },
                'IncludeEndValue': { n: 'includeEndValue', t: 1 }
            })
        ], RangeFilter);
        return RangeFilter;
    }(osa.base.Complex));
    search.RangeFilter = RangeFilter;
})(search || (search = {}));
(function (search) {
    var Remove = /** @class */ (function (_super) {
        __extends(Remove, _super);
        /**
        *
        * @param data - an initial data
        */
        function Remove(data) {
            return _super.call(this, data) || this;
        }
        Remove = __decorate([
            osa.decorators.ComplexType(search, 'search.Remove', {
                'DocumentIds': { n: 'documentIds', t: 2, f: 4 },
                'CollectionId': { n: 'collectionId', t: 2 },
                'MasterCollection': { n: 'masterCollection', t: 2 }
            })
        ], Remove);
        return Remove;
    }(osa.base.Complex));
    search.Remove = Remove;
})(search || (search = {}));
(function (search) {
    var RemoveResponse = /** @class */ (function (_super) {
        __extends(RemoveResponse, _super);
        /**
        *
        * @param data - an initial data
        */
        function RemoveResponse(data) {
            return _super.call(this, data) || this;
        }
        RemoveResponse = __decorate([
            osa.decorators.ComplexType(search, 'search.RemoveResponse', {
                'Success': { n: 'success', t: 1 },
                'Message': { n: 'message', t: 2 }
            })
        ], RemoveResponse);
        return RemoveResponse;
    }(osa.base.Complex));
    search.RemoveResponse = RemoveResponse;
})(search || (search = {}));
(function (search) {
    var ResultField = /** @class */ (function (_super) {
        __extends(ResultField, _super);
        /**
        *
        * @param data - an initial data
        */
        function ResultField(data) {
            return _super.call(this, data) || this;
        }
        ResultField = __decorate([
            osa.decorators.ComplexType(search, 'search.ResultField', {
                'FieldName': { n: 'fieldName', t: 2 },
                'FieldValue': { n: 'fieldValue', t: 2, f: 4 },
                'Type': { n: 'type', t: 4, r2: function () { return search.FieldType; } },
                'Highlighted': { n: 'highlighted', t: 1 }
            })
        ], ResultField);
        return ResultField;
    }(osa.base.Complex));
    search.ResultField = ResultField;
})(search || (search = {}));
(function (search) {
    var ResultGroup = /** @class */ (function (_super) {
        __extends(ResultGroup, _super);
        /**
        *
        * @param data - an initial data
        */
        function ResultGroup(data) {
            return _super.call(this, data) || this;
        }
        ResultGroup = __decorate([
            osa.decorators.ComplexType(search, 'search.ResultGroup', {
                'GroupId': { n: 'groupId', t: 2 },
                'TotalHitCount': { n: 'totalHitCount', t: 10 },
                'Documents': { n: 'documents', r: 'search.DocumentResult', r2: function () { return search.DocumentResult; }, f: 5 }
            })
        ], ResultGroup);
        return ResultGroup;
    }(osa.base.Complex));
    search.ResultGroup = ResultGroup;
})(search || (search = {}));
(function (search) {
    var ResultSort = /** @class */ (function (_super) {
        __extends(ResultSort, _super);
        /**
        *
        * @param data - an initial data
        */
        function ResultSort(data) {
            return _super.call(this, data) || this;
        }
        ResultSort = __decorate([
            osa.decorators.ComplexType(search, 'search.ResultSort', {
                'FieldName': { n: 'fieldName', t: 2 },
                'Order': { n: 'order', t: 4, r2: function () { return search.SortDirection; } }
            })
        ], ResultSort);
        return ResultSort;
    }(osa.base.Complex));
    search.ResultSort = ResultSort;
})(search || (search = {}));
(function (search) {
    var ResultSpec = /** @class */ (function (_super) {
        __extends(ResultSpec, _super);
        /**
        *
        * @param data - an initial data
        */
        function ResultSpec(data) {
            return _super.call(this, data) || this;
        }
        ResultSpec = __decorate([
            osa.decorators.ComplexType(search, 'search.ResultSpec', {
                'Start': { n: 'start', t: 9 },
                'Rows': { n: 'rows', t: 9 },
                'Sort': { n: 'sort', r: 'search.ResultSort', r2: function () { return search.ResultSort; }, f: 5 },
                'FragmentsStart': { n: 'fragmentsStart', t: 9 },
                'FragmentsRows': { n: 'fragmentsRows', t: 9 },
                'FragmentsSort': { n: 'fragmentsSort', t: 4, r2: function () { return search.FragmentSortType; } },
                'ReturnFields': { n: 'returnFields', t: 2, f: 4 },
                'AdvancedReturnFields': { n: 'advancedReturnFields', r: 'search.AdvancedReturnField', r2: function () { return search.AdvancedReturnField; }, f: 5 },
                'ResultGrouping': { n: 'resultGrouping', r: 'search.GroupingSpec', r2: function () { return search.GroupingSpec; }, f: 1 },
                'FilterGrouping': { n: 'filterGrouping', r: 'search.GroupingFilterSpec', r2: function () { return search.GroupingFilterSpec; }, f: 1 }
            })
        ], ResultSpec);
        return ResultSpec;
    }(osa.base.Complex));
    search.ResultSpec = ResultSpec;
})(search || (search = {}));
(function (search) {
    var ScoredTerm = /** @class */ (function (_super) {
        __extends(ScoredTerm, _super);
        /**
        *
        * @param data - an initial data
        */
        function ScoredTerm(data) {
            return _super.call(this, data) || this;
        }
        ScoredTerm = __decorate([
            osa.decorators.ComplexType(search, 'search.ScoredTerm', {
                'Term': { n: 'term', t: 2 },
                'Score': { n: 'score', t: 5 }
            })
        ], ScoredTerm);
        return ScoredTerm;
    }(osa.base.Complex));
    search.ScoredTerm = ScoredTerm;
})(search || (search = {}));
(function (search) {
    var SearchCollections = /** @class */ (function (_super) {
        __extends(SearchCollections, _super);
        /**
        *
        * @param data - an initial data
        */
        function SearchCollections(data) {
            return _super.call(this, data) || this;
        }
        SearchCollections = __decorate([
            osa.decorators.ComplexType(search, 'search.SearchCollections', {
                'CollectionIds': { n: 'collectionIds', t: 2, f: 4 },
                'Start': { n: 'start', t: 9 },
                'Rows': { n: 'rows', t: 9 }
            })
        ], SearchCollections);
        return SearchCollections;
    }(osa.base.Complex));
    search.SearchCollections = SearchCollections;
})(search || (search = {}));
(function (search) {
    var SpellCheck = /** @class */ (function (_super) {
        __extends(SpellCheck, _super);
        /**
        *
        * @param data - an initial data
        */
        function SpellCheck(data) {
            return _super.call(this, data) || this;
        }
        SpellCheck = __decorate([
            osa.decorators.ComplexType(search, 'search.SpellCheck', {
                'Query': { n: 'query', t: 2 },
                'CollectionId': { n: 'collectionId', t: 2 },
                'SpellSpec': { n: 'spellSpec', r: 'search.SpellSpec', r2: function () { return search.SpellSpec; }, f: 1 }
            })
        ], SpellCheck);
        return SpellCheck;
    }(osa.base.Complex));
    search.SpellCheck = SpellCheck;
})(search || (search = {}));
(function (search) {
    var SpellSpec = /** @class */ (function (_super) {
        __extends(SpellSpec, _super);
        /**
        *
        * @param data - an initial data
        */
        function SpellSpec(data) {
            return _super.call(this, data) || this;
        }
        SpellSpec = __decorate([
            osa.decorators.ComplexType(search, 'search.SpellSpec', {
                'MaxSuggestions': { n: 'maxSuggestions', t: 9 },
                'MaxQuerySuggestions': { n: 'maxQuerySuggestions', t: 9 },
                'MaxResultsForSuggest': { n: 'maxResultsForSuggest', t: 9 },
                'SpellCheckSource': { n: 'spellCheckSource', t: 2, f: 4 }
            })
        ], SpellSpec);
        return SpellSpec;
    }(osa.base.Complex));
    search.SpellSpec = SpellSpec;
})(search || (search = {}));
(function (search) {
    var SpellingSuggestions = /** @class */ (function (_super) {
        __extends(SpellingSuggestions, _super);
        /**
        *
        * @param data - an initial data
        */
        function SpellingSuggestions(data) {
            return _super.call(this, data) || this;
        }
        SpellingSuggestions = __decorate([
            osa.decorators.ComplexType(search, 'search.SpellingSuggestions', {
                'OriginalQuery': { n: 'originalQuery', t: 2 },
                'BestCorrection': { n: 'bestCorrection', t: 2 },
                'SuggestedSpellings': { n: 'suggestedSpellings', r: 'search.SuggestedSpellings', r2: function () { return search.SuggestedSpellings; }, f: 5 },
                'AlternateCorrections': { n: 'alternateCorrections', r: 'search.ScoredTerm', r2: function () { return search.ScoredTerm; }, f: 5 }
            })
        ], SpellingSuggestions);
        return SpellingSuggestions;
    }(osa.base.Complex));
    search.SpellingSuggestions = SpellingSuggestions;
})(search || (search = {}));
(function (search) {
    var StatFacetResult = /** @class */ (function (_super) {
        __extends(StatFacetResult, _super);
        /**
        *
        * @param data - an initial data
        */
        function StatFacetResult(data) {
            return _super.call(this, data) || this;
        }
        StatFacetResult = __decorate([
            osa.decorators.ComplexType(search, 'search.StatFacetResult', {
                'FacetTag': { n: 'facetTag', t: 2 },
                'Value': { n: 'value', t: 2 },
                'ValueType': { n: 'valueType', t: 2 }
            })
        ], StatFacetResult);
        return StatFacetResult;
    }(osa.base.Complex));
    search.StatFacetResult = StatFacetResult;
})(search || (search = {}));
(function (search) {
    var StatFunctionFacetSpec = /** @class */ (function (_super) {
        __extends(StatFunctionFacetSpec, _super);
        /**
        *
        * @param data - an initial data
        */
        function StatFunctionFacetSpec(data) {
            return _super.call(this, data) || this;
        }
        StatFunctionFacetSpec = __decorate([
            osa.decorators.ComplexType(search, 'search.StatFunctionFacetSpec', {
                'FacetTag': { n: 'facetTag', t: 2 },
                'StatFunction': { n: 'statFunction', t: 4, r2: function () { return search.StatFacetType; } },
                'StatField': { n: 'statField', t: 2 }
            })
        ], StatFunctionFacetSpec);
        return StatFunctionFacetSpec;
    }(osa.base.Complex));
    search.StatFunctionFacetSpec = StatFunctionFacetSpec;
})(search || (search = {}));
(function (search) {
    var SuggestedSpellings = /** @class */ (function (_super) {
        __extends(SuggestedSpellings, _super);
        /**
        *
        * @param data - an initial data
        */
        function SuggestedSpellings(data) {
            return _super.call(this, data) || this;
        }
        SuggestedSpellings = __decorate([
            osa.decorators.ComplexType(search, 'search.SuggestedSpellings', {
                'OriginalTerm': { n: 'originalTerm', t: 2 },
                'Suggestions': { n: 'suggestions', r: 'search.ScoredTerm', r2: function () { return search.ScoredTerm; }, f: 5 }
            })
        ], SuggestedSpellings);
        return SuggestedSpellings;
    }(osa.base.Complex));
    search.SuggestedSpellings = SuggestedSpellings;
})(search || (search = {}));
(function (search) {
    var SyntaxFaultCause = /** @class */ (function (_super) {
        __extends(SyntaxFaultCause, _super);
        /**
        *
        * @param data - an initial data
        */
        function SyntaxFaultCause(data) {
            return _super.call(this, data) || this;
        }
        SyntaxFaultCause = __decorate([
            osa.decorators.ComplexType(search, 'search.SyntaxFaultCause', {
                'Message': { n: 'message', t: 2 },
                'FaultType': { n: 'faultType', t: 4, r2: function () { return search.SyntaxFaultType; } },
                'Offset': { n: 'offset', t: 9 }
            })
        ], SyntaxFaultCause);
        return SyntaxFaultCause;
    }(osa.base.Complex));
    search.SyntaxFaultCause = SyntaxFaultCause;
})(search || (search = {}));
(function (search) {
    var TermsFilter = /** @class */ (function (_super) {
        __extends(TermsFilter, _super);
        /**
        *
        * @param data - an initial data
        */
        function TermsFilter(data) {
            return _super.call(this, data) || this;
        }
        TermsFilter = __decorate([
            osa.decorators.ComplexType(search, 'search.TermsFilter', {
                'FieldName': { n: 'fieldName', t: 2 },
                'Terms': { n: 'terms', t: 2, f: 4 },
                'AllowWildcards': { n: 'allowWildcards', t: 1 }
            })
        ], TermsFilter);
        return TermsFilter;
    }(osa.base.Complex));
    search.TermsFilter = TermsFilter;
})(search || (search = {}));
(function (search) {
    var AddResponse = /** @class */ (function (_super) {
        __extends(AddResponse, _super);
        /**
        *
        * @param data - an initial data
        */
        function AddResponse(data) {
            return _super.call(this, data) || this;
        }
        AddResponse = __decorate([
            osa.decorators.ComplexType(search, 'search.AddResponse', {
                'Success': { n: 'success', t: 1 },
                'Message': { n: 'message', t: 2 }
            })
        ], AddResponse);
        return AddResponse;
    }(osa.base.Complex));
    search.AddResponse = AddResponse;
})(search || (search = {}));
(function (search) {
    var InvalidHighlightFieldFault = /** @class */ (function (_super) {
        __extends(InvalidHighlightFieldFault, _super);
        /**
        *
        * @param data - an initial data
        */
        function InvalidHighlightFieldFault(data) {
            return _super.call(this, data) || this;
        }
        InvalidHighlightFieldFault = __decorate([
            osa.decorators.ComplexType(search, 'search.InvalidHighlightFieldFault', {
                'FieldName': { n: 'fieldName', t: 2 }
            })
        ], InvalidHighlightFieldFault);
        return InvalidHighlightFieldFault;
    }(common.AbstractFault));
    search.InvalidHighlightFieldFault = InvalidHighlightFieldFault;
})(search || (search = {}));
(function (search) {
    var InvalidSortFieldFault = /** @class */ (function (_super) {
        __extends(InvalidSortFieldFault, _super);
        /**
        *
        * @param data - an initial data
        */
        function InvalidSortFieldFault(data) {
            return _super.call(this, data) || this;
        }
        InvalidSortFieldFault = __decorate([
            osa.decorators.ComplexType(search, 'search.InvalidSortFieldFault', {
                'FieldName': { n: 'fieldName', t: 2 }
            })
        ], InvalidSortFieldFault);
        return InvalidSortFieldFault;
    }(common.AbstractFault));
    search.InvalidSortFieldFault = InvalidSortFieldFault;
})(search || (search = {}));
(function (search) {
    var InvalidQueryFault = /** @class */ (function (_super) {
        __extends(InvalidQueryFault, _super);
        /**
        *
        * @param data - an initial data
        */
        function InvalidQueryFault(data) {
            return _super.call(this, data) || this;
        }
        InvalidQueryFault = __decorate([
            osa.decorators.ComplexType(search, 'search.InvalidQueryFault', {
                'SyntaxFaultCauses': { n: 'syntaxFaultCauses', r: 'search.SyntaxFaultCause', r2: function () { return search.SyntaxFaultCause; }, f: 5 }
            })
        ], InvalidQueryFault);
        return InvalidQueryFault;
    }(common.AbstractFault));
    search.InvalidQueryFault = InvalidQueryFault;
})(search || (search = {}));
(function (search) {
    var InvalidPagingLimitFault = /** @class */ (function (_super) {
        __extends(InvalidPagingLimitFault, _super);
        /**
        *
        * @param data - an initial data
        */
        function InvalidPagingLimitFault(data) {
            return _super.call(this, data) || this;
        }
        InvalidPagingLimitFault = __decorate([
            osa.decorators.ComplexType(search, 'search.InvalidPagingLimitFault', {
                'PagingLimitValue': { n: 'pagingLimitValue', t: 2 }
            })
        ], InvalidPagingLimitFault);
        return InvalidPagingLimitFault;
    }(common.AbstractFault));
    search.InvalidPagingLimitFault = InvalidPagingLimitFault;
})(search || (search = {}));
(function (search) {
    var CollectionIdNotFoundFault = /** @class */ (function (_super) {
        __extends(CollectionIdNotFoundFault, _super);
        /**
        *
        * @param data - an initial data
        */
        function CollectionIdNotFoundFault(data) {
            return _super.call(this, data) || this;
        }
        CollectionIdNotFoundFault = __decorate([
            osa.decorators.ComplexType(search, 'search.CollectionIdNotFoundFault', {
                'Id': { n: 'id', t: 2 }
            })
        ], CollectionIdNotFoundFault);
        return CollectionIdNotFoundFault;
    }(common.AbstractFault));
    search.CollectionIdNotFoundFault = CollectionIdNotFoundFault;
})(search || (search = {}));
(function (search) {
    var InvalidDocumentIdFault = /** @class */ (function (_super) {
        __extends(InvalidDocumentIdFault, _super);
        /**
        *
        * @param data - an initial data
        */
        function InvalidDocumentIdFault(data) {
            return _super.call(this, data) || this;
        }
        InvalidDocumentIdFault = __decorate([
            osa.decorators.ComplexType(search, 'search.InvalidDocumentIdFault', {
                'Id': { n: 'id', t: 2 }
            })
        ], InvalidDocumentIdFault);
        return InvalidDocumentIdFault;
    }(common.AbstractFault));
    search.InvalidDocumentIdFault = InvalidDocumentIdFault;
})(search || (search = {}));
(function (search) {
    var InvalidCollectionIdFault = /** @class */ (function (_super) {
        __extends(InvalidCollectionIdFault, _super);
        /**
        *
        * @param data - an initial data
        */
        function InvalidCollectionIdFault(data) {
            return _super.call(this, data) || this;
        }
        InvalidCollectionIdFault = __decorate([
            osa.decorators.ComplexType(search, 'search.InvalidCollectionIdFault', {
                'Id': { n: 'id', t: 2 }
            })
        ], InvalidCollectionIdFault);
        return InvalidCollectionIdFault;
    }(common.AbstractFault));
    search.InvalidCollectionIdFault = InvalidCollectionIdFault;
})(search || (search = {}));
(function (search) {
    var InvalidClientIdFault = /** @class */ (function (_super) {
        __extends(InvalidClientIdFault, _super);
        /**
        *
        * @param data - an initial data
        */
        function InvalidClientIdFault(data) {
            return _super.call(this, data) || this;
        }
        InvalidClientIdFault = __decorate([
            osa.decorators.ComplexType(search, 'search.InvalidClientIdFault', {
                'Id': { n: 'id', t: 2 }
            })
        ], InvalidClientIdFault);
        return InvalidClientIdFault;
    }(common.AbstractFault));
    search.InvalidClientIdFault = InvalidClientIdFault;
})(search || (search = {}));
(function (search) {
    var DocumentIdNotFoundFault = /** @class */ (function (_super) {
        __extends(DocumentIdNotFoundFault, _super);
        /**
        *
        * @param data - an initial data
        */
        function DocumentIdNotFoundFault(data) {
            return _super.call(this, data) || this;
        }
        DocumentIdNotFoundFault = __decorate([
            osa.decorators.ComplexType(search, 'search.DocumentIdNotFoundFault', {
                'Id': { n: 'id', t: 2 }
            })
        ], DocumentIdNotFoundFault);
        return DocumentIdNotFoundFault;
    }(common.AbstractFault));
    search.DocumentIdNotFoundFault = DocumentIdNotFoundFault;
})(search || (search = {}));
(function (search) {
    var IndexingFault = /** @class */ (function (_super) {
        __extends(IndexingFault, _super);
        /**
        *
        * @param data - an initial data
        */
        function IndexingFault(data) {
            return _super.call(this, data) || this;
        }
        IndexingFault = __decorate([
            osa.decorators.ComplexType(search, 'search.IndexingFault', {})
        ], IndexingFault);
        return IndexingFault;
    }(common.AbstractFault));
    search.IndexingFault = IndexingFault;
})(search || (search = {}));
(function (search) {
    var TooBroadWildcardQueryFault = /** @class */ (function (_super) {
        __extends(TooBroadWildcardQueryFault, _super);
        /**
        *
        * @param data - an initial data
        */
        function TooBroadWildcardQueryFault(data) {
            return _super.call(this, data) || this;
        }
        TooBroadWildcardQueryFault = __decorate([
            osa.decorators.ComplexType(search, 'search.TooBroadWildcardQueryFault', {})
        ], TooBroadWildcardQueryFault);
        return TooBroadWildcardQueryFault;
    }(common.AbstractFault));
    search.TooBroadWildcardQueryFault = TooBroadWildcardQueryFault;
})(search || (search = {}));
(function (search) {
    /**
    * Entity Collection
    * Represents a collection of searchable documents.
    *
    */
    var Collection = /** @class */ (function (_super) {
        __extends(Collection, _super);
        /**
        * @param data - an initial data
        */
        function Collection(data) {
            return _super.call(this, data) || this;
        }
        /**
        * Expands the deferred property Documents making the request to the service if the property was not expanded earlier.
        *
        * @prop params - additional request arguments
        */
        Collection.prototype.getDocuments = function (params) { throw osa.error.NotImpl(); };
        /**
        * Request value of Documents property from server.
        *
        * @prop params - additional request arguments
        */
        Collection.prototype.requestDocuments = function (params) { throw new osa.error.NotImpl(); };
        /**
        * Add existing entity to Documents collection
        */
        Collection.prototype.addDocuments = function (entity) { throw osa.error.NotImpl(); };
        /**
        * Removes entity from Documents collection
        *
        */
        Collection.prototype.removeDocuments = function (entity) { throw osa.error.NotImpl(); };
        __decorate([
            osa.decorators.DeferredProperty(true)
        ], Collection.prototype, "documents", void 0);
        Collection = __decorate([
            osa.decorators.EntityType(search, 'search.Collection', {
                'Id': { n: 'id', t: 2 },
                'Name': { n: 'name', t: 2 },
                'Description': { n: 'description', t: 2 },
                'Contact': { n: 'contact', t: 2 },
                'Documents': { n: 'documents', r: 'search.Document', r2: function () { return search.Document; }, f: 6 }
            })
        ], Collection);
        return Collection;
    }(osa.base.Entity));
    search.Collection = Collection;
})(search || (search = {}));
(function (search) {
    /**
    * Entity Document
    * Represents a document in a collection. A document can be a simple collection of fields. In some cases the document is structured text (e.g. HTML, XML) which can be provided in the source field, and the properties can hold additional metadata associated with the document.
    *
    */
    var Document = /** @class */ (function (_super) {
        __extends(Document, _super);
        /**
        * @param data - an initial data
        */
        function Document(data) {
            return _super.call(this, data) || this;
        }
        Document = __decorate([
            osa.decorators.EntityType(search, 'search.Document', {
                'Id': { n: 'id', t: 2 },
                'PropertyValue': { n: 'propertyValue', r: 'search.PropertyValue', r2: function () { return search.PropertyValue; }, f: 5 },
                'MimeType': { n: 'mimeType', t: 2 },
                'Source': { n: 'source', t: 2 },
                'DocumentLanguage': { n: 'documentLanguage', t: 4, r2: function () { return search.Language; } }
            })
        ], Document);
        return Document;
    }(osa.base.Entity));
    search.Document = Document;
})(search || (search = {}));
(function (search) {
    var SearchOsaService = /** @class */ (function (_super) {
        __extends(SearchOsaService, _super);
        function SearchOsaService(context) {
            return _super.call(this, context) || this;
        }
        SearchOsaService_1 = SearchOsaService;
        Object.defineProperty(SearchOsaService.prototype, "collections", {
            /**
            * Gets Collections entity set
            *
            *
            */
            get: function () { return null; },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(SearchOsaService.prototype, "documents", {
            /**
            * Gets Documents entity set
            *
            *
            */
            get: function () { return null; },
            enumerable: false,
            configurable: true
        });
        /**
        * Get search results by querying a collection
        *
        * @prop params - additional requst arguments
        */
        SearchOsaService.prototype.executeQuery = function (request, params) { throw osa.error.NotImpl(); };
        /**
        * Get search results by querying a collection
        *
        * @prop params - additional requst arguments
        */
        SearchOsaService.prototype.executeQueryFromTree = function (request, params) { throw osa.error.NotImpl(); };
        /**
        * Get a highlighted document by querying the collection and documentid
        *
        * @prop params - additional requst arguments
        */
        SearchOsaService.prototype.highlightDocument = function (request, params) { throw osa.error.NotImpl(); };
        /**
        * Get a highlighted document by querying the collection and documentid
        *
        * @prop params - additional requst arguments
        */
        SearchOsaService.prototype.highlightDocumentFromTree = function (request, params) { throw osa.error.NotImpl(); };
        /**
        * Get highlights for arbitrary text
        *
        * @prop params - additional requst arguments
        */
        SearchOsaService.prototype.highlightText = function (request, params) { throw osa.error.NotImpl(); };
        /**
        * Get highlights for arbitrary text
        *
        * @prop params - additional requst arguments
        */
        SearchOsaService.prototype.highlightTextFromTree = function (request, params) { throw osa.error.NotImpl(); };
        /**
        * Given a query, returns suggested spellings for any terms in the query considered to be misspelled
        *
        * @prop params - additional requst arguments
        */
        SearchOsaService.prototype.spellCheck = function (request, params) { throw osa.error.NotImpl(); };
        /**
        * Add/update a document in the service
        *
        * @prop params - additional requst arguments
        */
        SearchOsaService.prototype.add = function (request, params) { throw osa.error.NotImpl(); };
        /**
        * Remove the document from the service
        *
        * @prop params - additional requst arguments
        */
        SearchOsaService.prototype.remove = function (request, params) { throw osa.error.NotImpl(); };
        /**
        * List import packages
        *
        * @prop params - additional requst arguments
        */
        SearchOsaService.prototype.imports = function (request, params) { throw osa.error.NotImpl(); };
        /**
        * List search collections
        *
        * @prop params - additional requst arguments
        */
        SearchOsaService.prototype.searchCollections = function (request, params) { throw osa.error.NotImpl(); };
        var SearchOsaService_1;
        __decorate([
            osa.decorators.EntitySet('Collections', search.Collection)
        ], SearchOsaService.prototype, "collections", null);
        __decorate([
            osa.decorators.EntitySet('Documents', search.Document)
        ], SearchOsaService.prototype, "documents", null);
        __decorate([
            osa.decorators.ServiceFunction('POST', 'Search_ExecuteQuery', [{ name: 'request', type: search.ExecuteQuery }], new osa.common.odata.OperationContext('search.ExecuteQueryResponse', false, null))
        ], SearchOsaService.prototype, "executeQuery", null);
        __decorate([
            osa.decorators.ServiceFunction('POST', 'Search_ExecuteQueryFromTree', [{ name: 'request', type: search.ExecuteQueryFromTree }], new osa.common.odata.OperationContext('search.ExecuteQueryFromTreeResponse', false, null))
        ], SearchOsaService.prototype, "executeQueryFromTree", null);
        __decorate([
            osa.decorators.ServiceFunction('POST', 'Search_HighlightDocument', [{ name: 'request', type: search.HighlightDocument }], new osa.common.odata.OperationContext('search.HighlightDocumentResponse', false, null))
        ], SearchOsaService.prototype, "highlightDocument", null);
        __decorate([
            osa.decorators.ServiceFunction('POST', 'Search_HighlightDocumentFromTree', [{ name: 'request', type: search.HighlightDocumentFromTree }], new osa.common.odata.OperationContext('search.HighlightDocumentFromTreeResponse', false, null))
        ], SearchOsaService.prototype, "highlightDocumentFromTree", null);
        __decorate([
            osa.decorators.ServiceFunction('POST', 'Search_HighlightText', [{ name: 'request', type: search.HighlightText }], new osa.common.odata.OperationContext('search.HighlightTextResponse', false, null))
        ], SearchOsaService.prototype, "highlightText", null);
        __decorate([
            osa.decorators.ServiceFunction('POST', 'Search_HighlightTextFromTree', [{ name: 'request', type: search.HighlightTextFromTree }], new osa.common.odata.OperationContext('search.HighlightTextFromTreeResponse', false, null))
        ], SearchOsaService.prototype, "highlightTextFromTree", null);
        __decorate([
            osa.decorators.ServiceFunction('POST', 'Search_SpellCheck', [{ name: 'request', type: search.SpellCheck }], new osa.common.odata.OperationContext('search.SpellingSuggestions', false, null))
        ], SearchOsaService.prototype, "spellCheck", null);
        __decorate([
            osa.decorators.ServiceFunction('POST', 'Document_Add', [{ name: 'request', type: search.Add }], new osa.common.odata.OperationContext('search.AddResponse', false, null))
        ], SearchOsaService.prototype, "add", null);
        __decorate([
            osa.decorators.ServiceFunction('POST', 'Document_Remove', [{ name: 'request', type: search.Remove }], new osa.common.odata.OperationContext('search.RemoveResponse', false, null))
        ], SearchOsaService.prototype, "remove", null);
        __decorate([
            osa.decorators.ServiceFunction('POST', 'Admin_Imports', [{ name: 'request', type: search.Imports }], new osa.common.odata.OperationContext('search.PackageInfo', true, null))
        ], SearchOsaService.prototype, "imports", null);
        __decorate([
            osa.decorators.ServiceFunction('POST', 'Admin_SearchCollections', [{ name: 'request', type: search.SearchCollections }], new osa.common.odata.OperationContext('search.CollectionInfo', true, null))
        ], SearchOsaService.prototype, "searchCollections", null);
        SearchOsaService = SearchOsaService_1 = __decorate([
            osa.decorators.DomainService(search, SearchOsaService_1)
        ], SearchOsaService);
        return SearchOsaService;
    }(osa.base.ServiceOdata3));
    search.SearchOsaService = SearchOsaService;
})(search || (search = {}));
module.exports = search;
// end of file
//# sourceMappingURL=index.js.map